import React from 'react';

import LocationAutocompleteGoogle from './LocationAutocompleteGoogle';

export default function LocationAutocomplete(props) {
    return <LocationAutocompleteGoogle {...props} />;
}
